import revive_payload_client_4sVQNw7RlN from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/app/plugins/revive-payload.client.js";
import router_jmwsqit4Rs from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/pages/runtime/plugins/router.js";
import payload_client_yVLowv6hDl from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/app/plugins/payload.client.js";
import components_plugin_KR1HBZs4kY from "C:/inetpub/gitlab-runner/navatel.ir-new-website/.nuxt/components.plugin.mjs";
import unhead_KgADcZ0jPj from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/head/runtime/plugins/unhead.js";
import prefetch_client_5tzzN0oIVL from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.js";
import plugin_yqYgmG0R8w from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt-lazy-hydrate/dist/runtime/plugin.mjs";
import chunk_reload_client_UciE0i6zes from "C:/inetpub/gitlab-runner/navatel.ir-new-website/node_modules/nuxt/dist/app/plugins/chunk-reload.client.js";
import helper_cbY2uVpm0F from "C:/inetpub/gitlab-runner/navatel.ir-new-website/plugins/helper.js";
export default [
  revive_payload_client_4sVQNw7RlN,
  router_jmwsqit4Rs,
  payload_client_yVLowv6hDl,
  components_plugin_KR1HBZs4kY,
  unhead_KgADcZ0jPj,
  prefetch_client_5tzzN0oIVL,
  plugin_yqYgmG0R8w,
  chunk_reload_client_UciE0i6zes,
  helper_cbY2uVpm0F
]